import {DraftGuessModelV1} from 'resources/GeneratedModels/DraftGuess/DraftGuessModel.v1';

import {draftGuessExtensions} from './draftGuess.extensions';

DraftGuessModelV1.extend(draftGuessExtensions);

export {DraftGuessModelV1};
